module.exports = __webpack_public_path__ + "img/pizza-icon.27fbfa96.svg";